import "./historyTable.css";
import React, { useState, useMemo, useEffect, useContext } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CloseImg from "../../../Assets/Modal-Assets/Close.png";
import "../../../global.css";
import CloseIcon from "@mui/icons-material/Close";
import { UserContext } from "../../UserProvider";
import InfoBar from "../../InfoBar/InfoBar";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import EyeIcon from "../../../Assets/tableAssets/iconoir_eye.png";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import emptybox from "../../../Assets/images/empty-box.png";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import DoneIcon from "@mui/icons-material/Done";
import Drawer from "@mui/material/Drawer";
import { LuSettings2 } from "react-icons/lu";
import { runInAction } from "mobx";
import { TbPoint } from "react-icons/tb";
import { v4 as uuidv4 } from "uuid";
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "white",
  borderRadius: "12px",
  width: 500,
  boxShadow: "0px 25px 50px -5px rgba(0, 0, 0, 0.25)",
  outline: "none",
};
import { Dropdown, Form } from "react-bootstrap";
import LaunchIcon from "@mui/icons-material/Launch";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Menu from "@mui/material/Menu";
import { useNavigate } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MenuItem from "@mui/material/MenuItem";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import PreviewIcon from "@mui/icons-material/Preview";
import EditIcon from "@mui/icons-material/Edit";
import ReactPaginate from "react-paginate";
import { useTable, usePagination, useRowSelect, useSortBy } from "react-table";
import { CommonPathWay } from "../../../Components/CommonPathWay";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Tooltip from "@mui/material/Tooltip";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ReorderOutlinedIcon from "@mui/icons-material/ReorderOutlined";
import TableFilterMenu from "../../TableFilterMenu/TableFilterMenu";
import { useLocation } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { useRootStore } from "../../../pages/ExperianPage/store/rootContext";
import { commonAxios } from "../../../pages/ExperianPage/CommonAxios";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import IconWithBackground from "../../../ui/icons/IconWithBackground";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 950,
  maxWidth: "100%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
const toPascalCase = (str) => {
  return str
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\b\w/g, (match) => match.toUpperCase());
};
const renderCellContent = (
  value,
  imageUrl = null,
  isImage = false,
  imageError,
  setImageError
) => {
  const displayValue = value ? value : "-";
  return (
    <div style={{ display: "flex", justifyContent: "left", cursor: "pointer" }}>
      {imageUrl === "" && displayValue !== "-" && (
        <Avatar
          {...stringAvatar(displayValue)}
          sx={{ width: 34, height: 36, bgcolor: "#6d2077" }}
        />
      )}
      <Tooltip
        title={
          <>
            <span>{displayValue}</span>
            <CopyToClipboard text={displayValue}>
              <ContentCopyIcon style={styles.copyIcon} />
            </CopyToClipboard>
          </>
        }
        enterDelay={500}
        enterNextDelay={300}
        placement="top"
        arrow
      >
        {" "}
        <span style={styles.spanCell}>{displayValue}</span>
      </Tooltip>
    </div>
  );
};
const HistoryTable = React.memo(
  ({
    fileName,
    setFileName,
    filelength,
    setFilelength,
    fileStatus,
    triggerChatSocket,
    setTriggerChatSocket,
    setFileStatus,
    progressValue,
    setProgressValue,
    data,
    setData,
    customData,
    commonvalues,
    tableType,
    inclusionExclusionRowDelete,
    getdatatable,
    chatAPIcallFunction,
    triggerMoreDetails,
    setTriggerMoreDetails,
    orderId,
    setOrderId,
    chatData,
    totalpage,
    setChatData,
    comments,
    setComments,
    userDetailsChat,
    sendMessageCall,
    newOrder,
    setNewOrder,
    setCustomDataValues,
    chatValueRef,
    userRole,
    handleFileDownload,
    reworkModal,
    setReworkModal,
    handleReWorkModal,
    placeExistingCount,
    setPlaceExistingCount,
    saveAsDraftFlag,
    setSaveAsDraftFlag,
    getOrderDetails,
    keyword,
    teamId,
    roleName,
    selectedOption,
    setSelectedOption,
    currentPage,
    setCurrentPage,
    onEntriesChange,
    pagination,
    tableName,
    fetchTeamMembers,
    allInternalUsers,
    setAllInternalUser,
    mentionedPeople,
    setMentionedPeople,
    gridTableData,
    allColumnNames,
    defaultColumns,
    selectedUser,
    setSelectedUser,
    chatType,
    setChatType,
    maporderPopup,
    setMatchOrderPopup,
  }) => {
    const [NewMoreDetails, setNewMoreDetails] = useState([]);
    const rootStore = useRootStore();
    const [deleteInfo, setDeleteInfo] = useState({
      selectedSearchID: null,
      deleteType: null,
    });
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerData, setDrawerData] = useState({});


    const [anchorEl, setAnchorEl] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
    const [popupdata, setpopupdata] = useState({});
    const [reworkData, setReWorkData] = useState({
      orderId: "",
      status: "",
      reworkDetails: "",
    });

    const {
      updateCredit,
      setDebitingCreditCount,
      creditAvailabilityVerification,
      globalrolename,
    } = useContext(UserContext);
    const [orderPlaced, setOrderPlaced] = useState(false);
    const [entriesToShow, setEntriesToShow] = useState(10);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const navigate = useNavigate();
    const [moreDetailsData, setMoreDetailsData] = useState([]);
    const [AssigneeData, setAssigneeData] = useState([]);
    const [dynamicColumns, setDynamicColumns] = useState([]);
    const [deleteOrderId, setDeleteOrderId] = useState("");
    const [filteredData, setFilterData] = useState([]);
    const location = useLocation();
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [selectedSearchID, setSelectedSearchID] = useState(null);
    const [deleteType, setDeleteType] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [drawerTitle, setDrawerTitle] = useState("Field Details");

    const handleDeleteClick = (searchID, type) => {
      setSelectedSearchID(searchID);
      setDeleteInfo(searchID);
      setDeleteType(type);
      setIsDialogOpen(true);
    };
    const handleDelete = async (searchID) => {
      try {
        const restCheck = await commonAxios(
          `/deleteSavedSearchAndInclusionExclusion`,
          "POST",
          {},
          {
            tableId: searchID?.id || searchID?._id,
            type: tableType === "Saved Search" ? "savedSearch" : "",
          }
        );
        if (restCheck) {
          getdatatable();
        }
      } catch (error) { }
    };
    const confirmDelete = (selectedSearchID, deleteType) => {
      setDeleteInfo({ selectedSearchID, deleteType });
      setIsDialogOpen(true);
    };
    const cancelDelete = () => {
      setSelectedSearchID(null);
      setIsDialogOpen(false);
    };
    useEffect(() => {
      const queryParams = new URLSearchParams(location.search);
      const id = queryParams.get("id");
      if (id && id !== null) {
        setTimeout(async () => {
          try {
            await getMoreDetailsData(id);
          } catch (error) { }
        }, 1000);
      }
    }, [location]);
    const handleDeleteModal = () => {
      setDeleteModal(false);
    };
    const handleViewDeleteModal = async (placeId) => {
      setDeleteOrderId(placeId);
      setDeleteModal(true);
    };
    function downloadCSV(url) {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    const handleEntriesToShowChange = (event) => {
      const entries = parseInt(event.target.value, 10);
      setEntriesToShow(entries);
      onEntriesChange(entries);
    };

    const calculateCreditCount = (packageType, totalLeads) => {
      switch (packageType) {
        case "Basic":
          return totalLeads;
        case "Medium":
          return Math.floor(totalLeads * 1.5);
        case "Extended":
          return totalLeads * 2;
        default:
          return totalLeads * 3;
      }
    };

    const shouldSkipCreditCheck = (requestType, role) =>
      !(requestType === "order" && role !== "Sales");

    const buildPostParams = (data, timestamp, teamId) => {
      const { trackDetails, status, updatedTimestamp, ...rest } = data;
      return {
        ...rest,
        status: "In Progress",
        updatedTimestamp: timestamp,
        teamId: teamId !== "Default" ? teamId : undefined,
      };
    };

    const handlePlaceOrderTable = async (orderData, placeId) => {
      const creditCount = calculateCreditCount(
        orderData?.package,
        orderData?.totalLeads
      );
      const formattedTimestamp = new Date().toISOString();

      if (!shouldSkipCreditCheck(orderData?.requestType, globalrolename)) {
        if (creditAvailabilityVerification(creditCount)) return;
      }

      const postParams = buildPostParams(orderData, formattedTimestamp, teamId);

      try {
        const response = await CommonPathWay(
          "/v1/placingReOrder",
          "POST",
          {},
          postParams
        );
        const alreadyDebited = response?.debit?.alreadyDebited === true;

        if (
          orderData?.status === "Draft" &&
          orderData?.requestType !== "count"
        ) {
          setDebitingCreditCount(creditCount);

          await updateCredit(
            alreadyDebited ? response?.debit?.debited : creditCount,
            "Custom data leads",
            "Custom Data",
            "customData",
            alreadyDebited
          );
        }

        setOrderPlaced(true);
        getOrderDetails();
        gridTableData();
      } catch (e) {
        console.error("Error placing order:", e);
      }
    };

    const getFilteredSelectedFields = (data) => {
      const result = {};

      const excludedKeys = [
        "startRange",
        "endRange",
        "minStartRange",
        "minEndRange",
        "maxStartRange",
        "maxEndRange",
      ];

      Object.entries(data).forEach(([key, value]) => {
        if (value?.selectedValues?.length > 0) {
          result[key] = value.selectedValues;
        } else if (value?.customOptions?.length > 0) {
          result[key] = value.customOptions;
        } else if (typeof value === "object") {
          const { minValue, maxValue, startRange, endRange } = value;

          const isMinMaxNullOrZero =
            (minValue === null ||
              minValue === "null" ||
              minValue === 0 ||
              minValue === "0") &&
            (maxValue === null ||
              maxValue === "null" ||
              maxValue === 0 ||
              maxValue === "0");

          const isSameAsRange =
            String(minValue) === String(startRange) &&
            String(maxValue) === String(endRange);

          if (!isMinMaxNullOrZero && !isSameAsRange) {
            const filteredEntries = Object.entries(value).filter(
              ([k, v]) => !excludedKeys.includes(k)
            );

            if (filteredEntries.length > 0) {
              result[key] = filteredEntries
                .map(([k, v]) => `${k}: ${v}`)
                .join(", ");
            }
          }
        }
      });

      return result;
    };

    const handleChange = (event, value) => {
      setCurrentPage(value - 1);
    };
    const handleReworkDetails = async () => {
      try {
        const response = await CommonPathWay(
          "/v1/customOrderRework",
          "POST",
          {},
          {
            orderId: reworkData?.orderId,
            reworkDetails: reworkData?.reworkDetails,
            status: reworkData?.status,
          }
        );
        console.log(response);
        setReWorkData({
          orderId: "",
          reworkDetails: "",
          status: "",
        });
        handleReWorkModal();
      } catch (e) {
        handleReWorkModal();
      }
    };
    const handleOrderChange = async (orderId) => {
      try {
        const response = await CommonPathWay(
          "/v1/customAccessChange",
          "POST",
          {},
          {
            orderId: orderId,
            type: "order",
          }
        );
        console.log(response);
        setOrderPlaced(true);
        getOrderDetails();
        gridTableData();
      } catch (e) { }
    };
    const handlePlaceOrder = async (status) => {
      let placeOrderId = deleteOrderId;
      let signedUrl;
      let fileKey;
      let fileUploadStatus;
      let updateDownloadLinkStatus;
      let postParams;
      const now = new Date();
      postParams = {
        orderId: placeOrderId,
        status: status,
      };
      if (status === "Deleted") {
        postParams = {
          orderId: placeOrderId,
          teamStatus: status,
        };
      }
      try {
        const response = await CommonPathWay(
          "/v1/customAccessChange",
          "POST",
          {},
          postParams
        );
        console.log(response);
        getOrderDetails();
        gridTableData();
        handleDeleteModal();
      } catch (e) { }
    };
    const dataList = data ?? [];
    let currentRows;
    currentRows = useMemo(() => {
      const limit = pagination?.limit ?? 0;
      const start = currentPage * limit;
      const end = start + limit;
      return dataList.slice(start, end);
    }, [currentPage, data, pagination?.limit]);
    useEffect(() => {
      if (tableName === "resultTable" || keyword === "emailValidation") {
        // Use frontend slicing
        const startIndex = currentPage * entriesToShow;
        const endIndex = startIndex + entriesToShow;
        const newData = dataList.slice(startIndex, endIndex);
        setFilterData(newData);
      } else if (
        tableType === "Inclusion and Exclusion" ||
        tableType === "Saved Search"
      ) {
        // Use server-paginated data directly
        setFilterData(dataList);
      }
    }, [
      data,
      dataList,
      tableName,
      keyword,
      tableType,
      currentPage,
      entriesToShow,
    ]);

    if (tableName === "resultTable" || keyword === "emailValidation") {
      currentRows = filteredData;
    } else if (
      tableType === "Inclusion and Exclusion" ||
      tableType === "Saved Search"
    ) {
      currentRows = dataList; // server-paginated data
    }

    let pageCount = Math.ceil(
      (data?.totalCount ?? 0) / (pagination?.limit ?? 10)
    );
    if (
      keyword === "emailValidation" ||
      tableType === "Saved Search" ||
      tableName === "resultTable" ||
      tableType === "Inclusion and Exclusion"
    ) {
      pageCount = Math.ceil(
        (data?.totalCount ?? dataList.length) / entriesToShow
      );
    }

    if (keyword === "emailValidation" || tableName === "resultTable") {
      pageCount = Math.ceil(
        (data?.totalCount ?? dataList.length) / entriesToShow
      );
    }
    if (
      tableType === "Inclusion and Exclusion" ||
      tableType === "Saved Search"
    ) {
      pageCount = Math.ceil(totalpage / entriesToShow);
    }
    // const download = async (id, fileNames) => {
    //   try {
    //     const bodyparam = {
    //       response_id: id.toString(),
    //     };
    //     const response = await CommonPathWay(
    //       "/v1/verifyEmailDataResult",
    //       "POST",
    //       {},
    //       bodyparam,
    //       {}
    //     );
    //     if (response?.apiResponses) {
    //       const apiResponses = response.apiResponses;
    //       const headerColumns = ["Email", "Contactable"];
    //       const formattedData = apiResponses.map((obj) => ({
    //         Email: obj.input,
    //         Contactable: obj.contactable,
    //       }));
    //       const worksheet = XLSX.utils.json_to_sheet(formattedData, {
    //         header: headerColumns,
    //       });
    //       const workbook = {
    //         Sheets: { data: worksheet },
    //         SheetNames: ["data"],
    //       };
    //       const excelBuffer = XLSX.write(workbook, {
    //         bookType: "csv",
    //         type: "array",
    //       });
    //       const blob = new Blob([excelBuffer], {
    //         type: "text/csv;charset=utf-8;",
    //       });
    //       const exportFilename = fileNames.split(".");
    //       const newfilesname = exportFilename[0];
    //       const filenames = `${commonvalues.suppressionType}${fileNames}`;
    //       const extension = ".csv";
    //       saveAs(blob, filenames + "" + extension);
    //     }
    //   } catch (error) {}
    // };
    const handleEditAndView = (
      btnType,
      saveSearchData,
      editSaveSearch,
      viewSaveSearch,
      searchType
    ) => {
      rootStore.applyTheValue({
        selectedSearchId: saveSearchData.id,
        savedSearchName: saveSearchData.title,
        tempsavedoldName: saveSearchData.title,
        apiFlag: true,
      });

      if (saveSearchData.type === "company") {
        localStorage.setItem("searchCompanyInfo", JSON.stringify(false));
      } else {
        localStorage.setItem("searchPeopleInfo", JSON.stringify(false));
      }
      runInAction(() => {
        rootStore.gridStore.tabIndex =
          saveSearchData.type === "company" ? 0 : 1;
      });
      rootStore.gridStore.offset = 0;
      rootStore.applyTheValue({
        apiFlag: true,
      });
      navigate(`/prospect-search`);
    };
    const getMoreDetailsData = async (row, type) => {
      const roleFlagMap = {
        "Super Admin": 3,
        Manager: 2,
        Supervisor: 2,
        Lead: 2,
        Owner: 1,
      };

      const flag = roleFlagMap[roleName] ?? 1;

      let orderId = "";

      if (type === "Similar Orders") {
        orderId = row;
      } else if (row?.original?.orderId) {
        orderId = row.original.orderId;
      } else {
        orderId = row ?? "";
      }

      const restCheck = await CommonPathWay(
        `/v1/getCustomOrderWithId`,
        "GET",
        {
          flag: flag,
          orderId: orderId,
        },
        {},
        {}
      );

      if (restCheck) {
        setNewMoreDetails(restCheck?.data ?? []);
        NewMoreDetailsSetValue(restCheck?.data[0]);
        setTriggerMoreDetails(true);
        setAssigneeData(restCheck?.data[0]?.assigneeData ?? []);
        setpopupdata(restCheck?.data[0]?.customProgress ?? []);
        if (type === "draft" || type === "reOrder") {
          setCustomDataValues(restCheck?.data[0] ?? []);
          setNewOrder(true);
        }
      }
    };
    const NewMoreDetailsSetValue = (rowValue) => {
      let companyEmailAcceptedValue = "NO";

      if (rowValue?.companyEmailAccepted === "custom") {
        companyEmailAcceptedValue = "custom";
      } else if (rowValue?.companyEmailAccepted === true) {
        companyEmailAcceptedValue = "Yes";
      }

      const formattedData = [
        {
          orderInformation: {
            taskName: rowValue?.taskName ?? "",
            updateOrderId: rowValue?.orderId,
            orderId: rowValue?.Order_Id,
            type: rowValue?.type,
            totalLeads: rowValue?.totalLeads,
            status: rowValue?.status,
          },
          packageDetails: {
            package: rowValue?.package,
          },
          sectorAndIndustries: {
            sectors: rowValue?.sectors,
            industry: rowValue?.industry,
            subIndustries: rowValue?.subIndustries,
          },
          location: {
            countries: rowValue?.countries,
            counties: rowValue?.counties,
            towns: rowValue?.towns,
            headOfficeCountries: rowValue?.headOfficeCountries,
            locationTypes: rowValue?.locationTypes,
          },
          generalInformation: {
            jobTitleLevel: rowValue?.jobTitleLevel,
            jobTitle: rowValue?.jobTitle,
            noOfContacts: rowValue?.contactsPerCompany,
            teleMarketingOrEmailMarketing: rowValue?.teleOrEmailMarketing,
            CompanyEmailAcceptedIfPersonalEmailIsNotAvailable:
              companyEmailAcceptedValue,
            PeopleScore: rowValue?.peopleScore?.toString() || "",
            companyScore: rowValue?.companyScore?.toString() || "",
          },
          companyDetails: {
            companyName: rowValue?.companyName,
            domain: rowValue?.domain,
            companyStatus: rowValue?.companyStatus,
            companyType: rowValue?.companyType,
            technologies: rowValue?.technologies,
          },
          turnoverAndEmployeeRange: {
            companyTurnoverRange: rowValue?.companyTurnoverRange,
            employeeRange: rowValue?.employeeRange,
            companyAge: rowValue?.companyAge,
          },
          classification: {
            sicCode: rowValue?.sicCode,
            accountCategory: rowValue?.accountCategory,
          },
          dataSources: {
            mapLink: rowValue?.mapLink,
            linkedinURL: rowValue?.linkedinURL,
            website: rowValue?.website,
          },
          additionalInformation: {
            additionalEmails: rowValue?.additionalEmail,
            deliveryEmail: rowValue?.deliveryEmail,
            additionalNotes: rowValue?.additionalDetails,
            referenceDocument: rowValue?.referenceFile,
            suppressionDocument: rowValue?.suppressionDocument,
          },
          assigneeData: rowValue?.assigneeData,
          orderStatus: {
            teamStatus: rowValue?.teamStatus,
            clientStatus: rowValue?.status,
            Eta: rowValue?.ETA,
            completedDate: rowValue?.completedDate,
          },
          trackDetails: rowValue?.trackDetails,
          priority: rowValue?.priority ?? "",
          internalTrack: rowValue?.internalTrack ?? "",
        },
      ];

      setMoreDetailsData(formattedData);
    };

    // useEffect(() => {
    //   if (data.length > 0) {
    //     data.forEach((row) => {
    //       if (orderId === row.orderId) {
    //       }
    //     });
    //   }
    // }, [data]);
    const allFieldNames = useMemo(() => {
      const fields = new Set();
      data?.forEach((row) => {
        Object.keys(row).forEach((key) => fields.add(key));
      });
      return [...fields];
    }, [data]);
    const imageFields = [
      "profileImageUrl",
      "companyLogoUrl",
      "imgURL",
      "companyImgURL",
    ];
    const formatLabel = (value) => {
      if (!value) return "";
      return value
        .replace(/_/g, " ") // replace underscores with space
        .split(" ")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1)) // capitalize each word
        .join(" ");
    };

    // const selectedFields = useMemo(() => {
    //   const fields = new Set();
    //   data?.forEach((row) => {
    //     Object.keys(row).forEach((key) => fields.add(key));
    //   });
    //   return [...fields].filter((field) => !imageFields.includes(field));
    // }, [data]);
    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
      <span
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
        style={{
          cursor: "pointer",
          display: "inline-flex",
          justifyContent: "left",
        }}
      >
        {children}
      </span>
    ));

    const getDownloadButton = (row) => {
      const s3Url = row?.original?.s3Url;
      const isRestricted = s3Url === "restricted";
      return s3Url !== null ? (
        <Button
          size="sm"
          onClick={() => handleFileDownload(s3Url)}
          disabled={isRestricted}
          style={{ cursor: isRestricted ? "not-allowed" : "pointer" }}
        >
          Download
        </Button>
      ) : (
        "-"
      );
    };

    // Helper function for CSV Download button
    const getCSVDownloadButton = (row) => {
      const downloadFile = row?.original?.downloadFile;
      const isInProgress = downloadFile === undefined || downloadFile === "-";
      return (
        <Button
          size="sm"
          variant="primary"
          style={{ background: "#6d2077", color: "white", border: "none" }}
          onClick={() => downloadCSV(downloadFile)}
          disabled={isInProgress}
        >
          {isInProgress ? "In Progress" : "Download"}
        </Button>
      );
    };

    // Helper function for Saved Search Actions (e.g., View, Delete)
    const getSavedSearchActionButtons = (row) => {
      // const [anchorEl, setAnchorEl] = useState(null);
      // const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
      // const handleClose = () => setAnchorEl(null);

      return (
        <div className="d-flex justify-content-left gap-5">
          <Button
            onClick={() => {
              handleEditAndView(
                "view",
                row.original,
                false,
                true,
                row.original.category
              );
              // handleClose();
            }}
            style={{
              color: "#E80070",
              fontSize: "12px",
              backgroundColor: "transparent",
              border: "none",
              display: "flex",
              alignItems: "center",
              padding: 0,
            }}
          >
            <img
              src={EyeIcon}
              alt="View"
              style={{ height: "16px", marginRight: "6px", fontSize: "14px" }}
            />
            Show
          </Button>
          <Button
            onClick={() => {
              handleDeleteClick(row.original, "saved-search");
              handleClose();
            }}
            style={{
              color: "#FA1320",
              fontSize: "12px",
              backgroundColor: "transparent",
              border: "none",
              display: "flex",
              alignItems: "center",
              padding: 0,
            }}
          >
            <DeleteOutlineOutlinedIcon
              style={{ fontSize: "14px", marginRight: "2px", color: "#FA1320" }}
            />
            Delete
          </Button>
        </div>
      );
    };

    const getCustomDataViewActions = (row) => {
      return (
        <div className="d-flex justify-content-around gap-1">
          <Dropdown>
            <Dropdown.Toggle
              as={CustomToggle}
              style={{ cursor: "pointer" }}
              id="dropdown-custom-toggle"
            >
              <MoreVertIcon
                sx={{
                  fontSize: 24,
                  cursor: "pointer",
                  color: userRole === 2 || userRole === 3 ? "white" : "gray",
                }}
              />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                className="dropdownItemaction"
                onClick={() => {
                  setOrderId(row?.original?.orderId);
                  getMoreDetailsData(row);
                }}
              >
                <PreviewIcon className="actionicons" />
                View Order Details
              </Dropdown.Item>
              {userRole != 1 && (
                <Dropdown.Item
                  onClick={() => {
                    setOrderId(row?.original?.orderId);
                    setMatchOrderPopup(true);
                  }}
                  className="dropdownItemaction"
                >
                  <RemoveRedEyeIcon className="actionicons" />
                  Mapping Orders
                </Dropdown.Item>
              )}
              {row?.original?.status === "Draft" &&
                (userRole === 1 || userRole === 3) && (
                  <Dropdown.Item
                    onClick={() => {
                      getMoreDetailsData(row, "draft");
                      setSaveAsDraftFlag(true);
                    }}
                    className="dropdownItemaction"
                  >
                    <>
                      <EditIcon className="actionicons" />
                      Edit Draft Order
                    </>
                  </Dropdown.Item>
                )}
              {row?.original?.status === "Draft" &&
                (userRole === 1 || userRole === 3) && (
                  <Dropdown.Item
                    onClick={() => {
                      handlePlaceOrderTable(
                        row?.original,
                        row?.original?.orderId
                      );
                    }}
                    className="dropdownItemaction"
                  >
                    <>
                      <UpgradeIcon className="actionicons" />
                      Place Draft Order
                    </>
                  </Dropdown.Item>
                )}
              {row?.original?.type === "count" &&
                row?.original?.teamStatus === "Completed" &&
                roleName !== "Manager" &&
                roleName !== "Supervisor" &&
                roleName !== "Lead" && (
                  <Dropdown.Item
                    onClick={() => {
                      handleOrderChange(row?.original?.orderId);
                    }}
                    className="dropdownItemaction"
                  >
                    <>
                      <ReorderOutlinedIcon className="actionicons" />
                      Change Count To Order
                    </>
                  </Dropdown.Item>
                )}
              {row?.original?.status === "Completed" && userRole === 1 && (
                <Dropdown.Item
                  onClick={() => {
                    getMoreDetailsData(row, "reOrder");
                    setNewOrder(true);
                    setPlaceExistingCount(true);
                  }}
                  className="dropdownItemaction"
                >
                  <BorderColorIcon className="actionicons" />
                  Re-order
                </Dropdown.Item>
              )}
              {userRole === 3 && (
                <>
                  {row?.original?.status === "Completed" && (
                    <Dropdown.Item
                      onClick={() => {
                        setReWorkData((prev) => ({
                          ...prev,
                          orderId: row?.original?.orderId,
                          status: "rework",
                        }));
                        setReworkModal(true);
                      }}
                      className="dropdownItemaction"
                    >
                      <RestartAltIcon className="actionicons" />
                      Rework Order
                    </Dropdown.Item>
                  )}
                  <Dropdown.Item
                    onClick={() => {
                      handleViewDeleteModal(row?.original?.orderId);
                    }}
                    className="dropdownItemaction"
                  >
                    <CloseIcon className="actionicons" />
                    Delete Order
                  </Dropdown.Item>
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>
          { }
        </div>
      );
    };

    const getCustomDataTaskActions = (row) => {
      const [anchorEl, setAnchorEl] = React.useState(null);
      const handleOpenPopover = (event) => {
        setAnchorEl(event.currentTarget);
      };
      const handleClosePopover = () => {
        setAnchorEl(null);
      };
      const open = Boolean(anchorEl);
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "left",
            width: "90%",
            gap: "10px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              maxWidth: "230px",
              width: "100%",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            <Tooltip
              title={value}
              arrow
              disableInteractive
              placement="top"
            >
              <span
                className="taskBtn"
                style={{ cursor: "pointer" }}
                tabIndex={0}
                onClick={() => {
                  setOrderId(row?.original?.orderId);
                  getMoreDetailsData(row);
                }}
              >
                {value?.length >= 8
                  ? `${value.slice(0, 18)}...`
                  : value.padEnd(18, " ")}
              </span>
            </Tooltip>
          </div>
          <div>
            {" "}
            {userRole != 1 && (
              <Link
                to={`/editable-grid/${row?.original?.orderId}`}
                className="daily-update-link"
              >
                <LaunchIcon
                  style={{
                    width: "15px",
                    height: "15px",
                    verticalAlign: "middle",
                    color: "#ffffff",
                  }}
                />
              </Link>
            )}
          </div>
          <div className="mapcountdiv">
            {row?.original?.similarOrders !== undefined &&
              row?.original?.similarOrders.length > 0 ? (
              <>
                <Tooltip title="Similar Order" position="top">
                  <span
                    onClick={handleOpenPopover}
                    style={{
                      cursor: "pointer",
                      justifyContent: "left",
                    }}
                    className="count-icon"
                  >
                    {row?.original?.similarOrders.length}
                  </span>
                </Tooltip>
                <Popover
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClosePopover}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  PaperProps={{
                    style: {
                      zIndex: 999999,
                      minWidth: "200px",
                    },
                  }}
                >
                  <div>
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: "14px",
                        borderBottom: "1px solid #e0e0e0",
                        color: "#333",
                        backgroundColor: "#f7f7f7",
                      }}
                    >
                      <div style={{ padding: "10px" }}>
                        Similar Orders
                      </div>
                    </div>
                    <div style={{ padding: "10px", maxHeight: "200px" }}>
                      <ul style={{ paddingLeft: "20px", margin: 0 }}>
                        {row?.original?.similarOrders?.map((id, idx) => (
                          <li
                            key={uuidv4()}
                            onClick={() => {
                              setOrderId(id?.orderId);
                              getMoreDetailsData(
                                id.orderId,
                                "Similar Orders"
                              );
                              handleClosePopover();
                            }}
                            className="order-id-item"
                            style={{
                              cursor: "pointer",
                              marginBottom: "4px",
                            }}
                          >
                            <Typography
                              variant="body2"
                              style={{ fontSize: "12px" }}
                            >
                              {id?.recordId} ({id?.taskName})
                            </Typography>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </Popover>
              </>
            ) : (
              <div style={{ padding: "8px" }}></div>
            )}{" "}
          </div>
        </div>
      );
    }

    const getStatusActions = (row) => {
      const { original } = row;
      const statusClasses = {
        "In Progress": "bg-primary text-white",
        Completed: "bg-success text-white",
        Draft: "draftText",
        rework: "bg-primary text-white",
        hold: "holdText",
      };
      return (
        <div className="d-flex justify-content-around">
          <span
            className={`${statusClasses[original.status] || ""
              } statusAlign`}
          >
            {original.status === "rework"
              ? "In Progress"
              : original.status || "Unknown Status"}
          </span>
        </div>
      );
    }

    const getCustomView = (row) => {
      const { original } = row;
      return (
        <div className="d-flex justify-content-around">
          {original?.teamManager?.length > 0 ? (
            <span>{original.teamManager.join(", ")}</span>
          ) : (
            <span>-</span>
          )}
        </div>
      );
    }

    const getUpdatedAction = (row) => {
      const { original } = row;
      const formatDateTime = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = date.getHours() % 12 || 12;
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = date.getHours() >= 12 ? "PM" : "AM";
        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
      };
      const formattedDate = formatDateTime(original.updatedTimestamp);
      return (
        <div>
          <span>{formattedDate}</span>
        </div>
      );
    }

    const getCustomOwner = (row) => {
      const { original } = row;
      return (
        <div className="d-flex justify-content-around">
          {Array.isArray(original?.teamOwner) &&
            original?.teamOwner?.length > 0 ? (
            <span>{original.teamOwner.join(", ")}</span>
          ) : (
            <span>{original?.teamOwner}</span>
          )}
        </div>
      );
    }

    const getCustomAssignees = (row) => {
      const { original } = row;
      return (
        <div className="d-flex justify-content-around">
          {original?.assignees?.length > 0 ? (
            <Tooltip title={original.assignees.join(", ")} arrow>
              <span style={{ cursor: "pointer" }}>
                {original.assignees.join(", ").length > 12
                  ? `${original.assignees.join(", ").slice(0, 12)}...`
                  : original.assignees.join(", ")}
              </span>
            </Tooltip>
          ) : (
            <span>-</span>
          )}
        </div>
      );
    }

    const getCustomTeamName = (row) => {
      const { original } = row;
      return (
        <div className="d-flex justify-content-around">
          {original?.teamName !== undefined &&
            original?.teamName !== null ? (
            <span>{toPascalCase(original?.teamName)}</span>
          ) : (
            <span>-</span>
          )}
        </div>
      );
    }

    const getInclusion = (row) => {
      const { original } = row;
      let fieldValues = "-";
      if (original?.fields) {
        try {
          const parsed = JSON.parse(original.fields);
          fieldValues = Object.values(parsed).join(", ");
        } catch (error) {
          fieldValues = "Invalid Data";
        }
      }
      return (
        <div className="d-flex justify-content-start">
          <Tooltip
            title={
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                {fieldValues}
                <CopyToClipboard text={fieldValues}>
                  <ContentCopyIcon style={styles.copyIcon} />
                </CopyToClipboard>
              </span>
            }
            placement="top"
            arrow
          >
            <span>
              {fieldValues.length > 8
                ? `${fieldValues.slice(0, 8)}...`
                : fieldValues}
            </span>
          </Tooltip>
        </div>
      );
    }

    const getDate = (row) => {
      const { original } = row;
      const formatDateTime = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = date.getHours() % 12 || 12;
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = date.getHours() >= 12 ? "PM" : "AM";
        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
      };
      const formattedDate = formatDateTime(original.date);
      return (
        <div className="d-flex justify-content-around">
          <span>{formattedDate}</span>
        </div>
      );
    }

    const getCreateDate = (row) => {
      const { original } = row;
      function formatDate(input) {
        if (typeof input !== "string") {
          return "-";
        }
        let date = new Date(input);
        if (isNaN(date.getTime())) {
          return "-";
        }
        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const amPm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        const getOrdinalSuffix = (day) => {
          if (day >= 11 && day <= 13) return "th";
          switch (day % 10) {
            case 1:
              return "st";
            case 2:
              return "nd";
            case 3:
              return "rd";
            default:
              return "th";
          }
        };
        const dayWithSuffix = `${day}${getOrdinalSuffix(day)}`;
        const formattedMinutes = minutes.toString().padStart(2, "0");
        return `${dayWithSuffix} ${month} ${year} ${hours}:${formattedMinutes} ${amPm}`;
      }
      const formattedDate = formatDate(original.createdDate);
      return (
        <div className="d-flex justify-content-around">
          <span>{formattedDate}</span>
        </div>
      );
    }

    const getETAAction = (row) => {
      const { original } = row;
      function formatDate(input) {
        if (typeof input !== "string") {
          return "-";
        }
        let date = new Date(input);
        if (isNaN(date.getTime())) {
          return "-";
        }
        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();
        const getOrdinalSuffix = (day) => {
          if (day >= 11 && day <= 13) return "th";
          switch (day % 10) {
            case 1:
              return "st";
            case 2:
              return "nd";
            case 3:
              return "rd";
            default:
              return "th";
          }
        };
        const dayWithSuffix = `${day}${getOrdinalSuffix(day)}`;
        return `${dayWithSuffix} ${month} ${year}`;
      }
      const formattedDate = formatDate(original.ETA);
      return (
        <div className="d-flex justify-content-around">
          <span>{formattedDate}</span>
        </div>
      );
    }

    const getCompletedAction = (row) => {
      const { original } = row;
      function formatDate(input) {
        if (typeof input !== "string") {
          return "-";
        }
        const date = new Date(input);
        if (isNaN(date.getTime())) {
          return "-";
        }
        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const amPm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        const getOrdinalSuffix = (day) => {
          if (day >= 11 && day <= 13) return "th";
          switch (day % 10) {
            case 1:
              return "st";
            case 2:
              return "nd";
            case 3:
              return "rd";
            default:
              return "th";
          }
        };
        const dayWithSuffix = `${day}${getOrdinalSuffix(day)}`;
        const formattedMinutes = minutes.toString().padStart(2, "0");
        return `${dayWithSuffix} ${month} ${year} ${hours}:${formattedMinutes} ${amPm}`;
      }
      const formattedDate = formatDate(original.completedDate);
      return (
        <div className="d-flex justify-content-around">
          <span>{formattedDate}</span>
        </div>
      );
    }

    const getUpdatedTimeStampAction = (row) => {
      const { original } = row;
      function formatTimestampForUI(timestamp) {
        const date = new Date(timestamp);
        const options = {
          year: "numeric",
          month: "long",
          day: "2-digit",
        };
        return date.toLocaleDateString("en-GB", options);
      }
      const formattedDate = formatTimestampForUI(
        original.createdAt || original?.updatedTimestamp
      );
      return (
        <div className="d-flex justify-content-left">
          <Tooltip
            title={
              <span
                style={{
                  display: "flex",
                  alignItems: "left",
                  gap: "6px",
                }}
              >
                {original.createdAt}
                <CopyToClipboard text={original.createdAt}>
                  <ContentCopyIcon style={styles.copyIcon} />
                </CopyToClipboard>
              </span>
            }
            enterDelay={500}
            enterNextDelay={300}
            placement="top"
            arrow
          >
            <span>{formattedDate}</span>
          </Tooltip>
        </div>
      );
    }

    const getInclusionAction = (row) => {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "left",
            cursor: "pointer",
          }}
          onClick={() =>
            confirmDelete(row?.original?._id, "inclusion-exclusion")
          }
        >
          {" "}
          <DeleteOutlineOutlinedIcon
            style={{
              color: "red",
              cursor: "pointer",
              marginBottom: "3px",
              fontSize: "14px",
            }}
          />
          <span
            style={{
              color: "red",
              marginLeft: "4px",
              fontSize: "12px",
              fontWeight: "400",
            }}
          >
            Delete
          </span>
        </div>
      );
    }

    const getInclusionStatus = (row) => {
      console.log(row, "Got in data for row in history table")
      const status = row?.original?.status?.toLowerCase(); // normalize status

      return status === "completed" ? (
        <span
          style={{
            color: "#1A4D31",
            border: "1px solid #92DCAE",
            backgroundColor: "#F1FBF4",
            fontSize: "12px",
            borderRadius: "15px",
            padding: "3px 10px",
            display: "inline-flex",
            alignItems: "center",
            width: "120px",
          }}
        >
          <DoneIcon
            style={{
              color: "#1A4D31",
              fontSize: "14px",
              marginRight: "10px",
            }}
          />
          <span style={{ paddingTop: "1px" }}>
            {" "}
            {status.charAt(0).toUpperCase() + status.slice(1)}
          </span>
        </span>
      ) : (
        <span
          style={{
            color: "#653912",
            border: "1px solid #FFC400",
            backgroundColor: "#FFFCF0",
            fontSize: "12px",
            borderRadius: "15px",
            padding: "3px 10px",
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            width: "120px",
            justifyContent: "center",
          }}
        >
          {status === "progress" && (
            <span style={{ display: "flex", alignItems: "center" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16px"
                height="16px"
                viewBox="0 0 40 40"
              >
                <path
                  opacity="0.2"
                  fill="#000"
                  d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946
             c0,8.255,6.692,14.946,14.946,14.946
             s14.946-6.691,14.946-14.946
             C35.146,11.861,28.455,5.169,20.201,5.169z
             M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
             c0-6.425,5.209-11.634,11.634-11.634
             c6.425,0,11.633,5.209,11.633,11.634
             C31.834,26.541,26.626,31.749,20.201,31.749z"
                />
                <path
                  fill="#FF6700"
                  d="M26.013,10.047l1.654-2.866
             c-2.198-1.272-4.743-2.012-7.466-2.012v3.312
             C22.32,8.481,24.301,9.057,26.013,10.047z"
                >
                  <animateTransform
                    attributeType="xml"
                    attributeName="transform"
                    type="rotate"
                    from="0 20 20"
                    to="360 20 20"
                    dur="0.5s"
                    repeatCount="indefinite"
                  />
                </path>
              </svg>
            </span>
          )}
          <span style={{ paddingTop: "1px", marginLeft: "10px" }}>
            {" "}
            {status === "progress"
              ? "In Progress"
              : status.charAt(0).toUpperCase() + status.slice(1)}
          </span>
        </span>
      );
    }

    const getTableColumn = (field, tableType) => {
      if (field === "Action" && tableType === "result file details") {
        return {
          id: "download",
          Header: "Download",
          accessor: "download",
          Cell: ({ row }) => getDownloadButton(row),
        };
      }

      if (
        field === "Download" &&
        ![
          "Saved Search",
          "custom data view table",
          "Inclusion and Exclusion",
          "result file details",
        ].includes(tableType)
      ) {
        return {
          id: "download",
          Header: "Download",
          accessor: "download",
          Cell: ({ row }) => getCSVDownloadButton(row),
        };
      }

      if (tableType === "Saved Search" && field === "Action") {
        return {
          id: "action",
          Header: "Action",
          accessor: "action",
          Cell: ({ row }) => getSavedSearchActionButtons(row),
        };
      }

      if (tableType === "custom data view table" && field === "Action") {
        return {
          id: "action",
          Header: "Action",
          accessor: "action",
          Cell: ({ row }) => getCustomDataViewActions(row),
        };
      }
      if (tableType === "custom data view table" && field === "taskName") {
        return {
          id: "taskName",
          Header: "Task Name",
          accessor: "taskName",
          Cell: ({ row }) => getCustomDataTaskActions(row),
        };
      }
      if (
        tableType === "custom data view table" &&
        field === "clientStatus" &&
        tableType !== "Single Email Table"
      ) {
        return {
          id: "status",
          Header: userRole === 2 || userRole === 3 ? "Client Status" : "Status",
          accessor: "status",
          Cell: ({ row }) => getStatusActions(row),
        };
      }
      if (tableType === "custom data view table" && field === "teamManager") {
        return {
          id: "teamManager",
          Header: "Team Manager",
          accessor: "teamManager",
          Cell: ({ row }) => getCustomView(row),
        };
      }
      if (field === "updatedAt") {
        return {
          id: "updatedAt",
          Header: "updated At",
          accessor: "updatedAt",
          Cell: ({ row }) => getUpdatedAction(row),
        };
      }
      if (tableType === "custom data view table" && field === "teamOwner") {
        return {
          id: "teamOwner",
          Header: "Team Manager",
          accessor: "teamOwner",
          Cell: ({ row }) => getCustomOwner(row),
        };
      }
      if (tableType === "custom data view table" && field === "assignees") {
        return {
          id: "assignees",
          Header: "Assignees",
          accessor: "assignees",
          Cell: ({ row }) => getCustomAssignees(row),
        };
      }
      if (tableType === "custom data view table" && field === "teamName") {
        return {
          id: "teamName",
          Header: "Team Name",
          accessor: "teamName",
          Cell: ({ row }) => getCustomTeamName(row),
        };
      }
      if (tableType === "Inclusion and Exclusion" && field === "fields") {
        return {
          id: "fields",
          Header: "Fields",
          accessor: "fields",
          Cell: ({ row }) => getInclusion(row),
        };
      }
      if (field === "date") {
        return {
          id: "date",
          Header: "Date",
          accessor: "date",
          Cell: ({ row }) => getDate(row),
        };
      }
      if (field === "createdDate") {
        return {
          id: "createdDate",
          Header: "Created Date",
          accessor: "createdDate",
          Cell: ({ row }) => getCreateDate(row),
        };
      }
      if (field === "ETA") {
        return {
          id: "ETA",
          Header: "ETA",
          accessor: "ETA",
          Cell: ({ row }) => getETAAction(row),
        };
      }
      if (field === "completedDate") {
        return {
          id: "completedDate",
          Header: "Completed Date",
          accessor: "completedDate",
          Cell: ({ row }) => getCompletedAction(row),
        };
      }
      if (field === "createdAt" || field === "updatedTimestamp") {
        return {
          id: "createdAt",
          Header: "Updated At",
          accessor: "createdAt",
          Cell: ({ row }) => getUpdatedTimeStampAction(row),
        };
      }
      if (tableType === "Inclusion and Exclusion" && field === "Action") {
        return {
          id: "action",
          Header: "Action",
          accessor: "action",
          Cell: ({ row }) => getInclusionAction(row),
        };
      }

      if (tableType === "Inclusion and Exclusion" && field === "Status") {
        return {
          id: "status",
          Header: "Status",
          accessor: "status",
          Cell: ({ row }) => getInclusionStatus(row),
        };
      }

      // Default cell rendering for other fields
      return {
        Header: toPascalCase(field),
        accessor: field,
        Cell: ({ value }) => renderCellContent(value),
      };
    };

    const baseColumns = useMemo(() => {
      let includedFields = [];
      if (
        tableType !== "Saved Search" &&
        tableType !== "custom data view table" &&
        tableType !== "Inclusion and Exclusion" &&
        tableType !== "result file details" &&
        tableType !== "Single Email Table"
      ) {
        includedFields.push("Download");
      }
      if (
        tableType === "Saved Search" ||
        tableType === "custom data view table" ||
        tableType === "Inclusion and Exclusion" ||
        tableType === "result file details"
      ) {
        includedFields.push("Action");
      }
      if (tableType === "Inclusion and Exclusion") {
        includedFields.push("Status");
      }
      if (tableType === "Saved Search") {
        includedFields.push("Selected Fields");
      }
      const excludedFields = [
        "profileImageUrl",
        "companyLogoUrl",
        "imgURL",
        "companyImgURL",
        "trackingId",
        " v",
        "v",
        "V",
        " V",
        "user_id",
        "responseId",
        "userId",
        "_id",
        "bounce",
        "spam",
        "saveSearchId",
        "trackDetails",
        "filter",
        "orderId",
        "additionalEmail",
        "emailAddress",
        "userId",
        "contactsPerCompany",
        "industry",
        "jobTitleLevel",
        "jobTitle",
        "companyTurnoverRange",
        "employeesRange",
        "companyAge",
        "contacts",
        "page",
        "orderId",
        "page",
        "revenue",
        "verifiedEmails",
        "downloadFile",
        "additionalEmail",
        "emailAddress",
        "userId",
        "contactsPerCompany",
        "industry",
        "jobTitleLevel",
        "additionalDetails",
        "jobTitle",
        "companyTurnoverRange",
        "employeesRange",
        "companyAge",
        "googleMapUrl",
        "websiteUrl",
        "linkedInUrl",
        "contacts",
        "__v",
        "companyScore",
        "package",
        "accountCategory",
        "includes",
        "sicCode",
        "emailScore",
        "saveName",
        "technologies",
        "companyType",
        "companyStatus",
        "domain",
        "companyName",
        "headOfficeCountries",
        "teleOrEmailMarketing",
        "locationTypes",
        "countries",
        "audienceCriteria",
        "sectors",
        "counties",
        "towns",
        "subIndustries",
        "requestType",
        "referenceFile",
        "suppressionDocument",
        "trackDetails",
        "googleMapUrl",
        "websiteUrl",
        "package",
        "s3Url",
        "internalTrack",
        "additionalDetails",
        "reworkCount",
        "requestType",
        "exclusion_id",
        "data",
        "table_id",
        "assigneeData",
      ];
      if (
        tableType !== "custom data view table" &&
        tableType !== "result file details" &&
        tableType !== "Single Email Table" &&
        tableType !== "Inclusion and Exclusion"
      ) {
        excludedFields.push("status");
      }
      if (keyword === "emailValidation") {
        excludedFields.push("file_name");
      }
      if (tableType === "Saved Search") {
        excludedFields.push("id");
      }
      if (tableType === "result file details" && userRole === 1) {
        excludedFields.push("reworkDetails");
        excludedFields.push("details");
      }
      if (
        userRole !== undefined &&
        (roleName === "User" || roleName === "FreeUser")
      ) {
        excludedFields.push("userName");
      }
      const remainingFields = allFieldNames.filter(
        (field) => !excludedFields.includes(field)
      );
      const finalFields = [...remainingFields, ...includedFields];
      const desiredOrder = [
        "taskName",
        "type",
        "totalLeads",
        "createdDate",
        "ETA",
        "clientStatus",
        "teamStatus",
        "updatedAt",
        "assignees",
        "teamOwner",
        "teamName",
      ];
      const keyMapping = {
        status: "clientStatus",
        updatedTimestamp: "updatedAt",
      };
      const mappedArray = finalFields.map((item) => keyMapping[item] || item);
      const sortedFields = desiredOrder.filter((item) =>
        mappedArray.includes(item)
      );
      const excessFields = mappedArray.filter(
        (item) => !desiredOrder.includes(item)
      );
      let finalSortedArray = [...sortedFields, ...excessFields];
      if (tableType === "custom data view table") {
        finalSortedArray = finalSortedArray.filter((element) => {
          return defaultColumns.includes(element);
        });
      }

      // Return final columns with mappings
      return finalSortedArray.map((field) => getTableColumn(field, tableType));

    }, [allFieldNames, data, defaultColumns]);

    const columns = useMemo(() => {
      const commonColumns = [...baseColumns, ...dynamicColumns];
      if (
        roleName === "Super Admin" &&
        defaultColumns.includes("additionalEmail")
      ) {
        return [
          ...commonColumns,
          {
            Header: "Email Address",
            accessor: "emailAddress",
          },
          {
            Header: "Additional Email",
            accessor: "additionalEmail",
            Cell: ({ value }) => (value?.length ? value.join(", ") : "N/A"),
          },
        ];
      }
      return commonColumns;
    }, [baseColumns, dynamicColumns, roleName]);
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
      state: { selectedRowIds },
    } = useTable(
      {
        columns,
        data: currentRows,
        initialState: { pageIndex: 0, pageSize: 10 },
      },
      useSortBy,
      usePagination,
      useRowSelect,
      (hooks) => {
        hooks.visibleColumns.push((columns) => [...columns]);
      }
    );
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedType, setSelectedType] = useState(null);
    const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
    const [isTypeDropdownOpen, setIsTypeDropdownOpen] = useState(false);
    const statusOptions = ["Completed", "Draft", "In Progress"];
    const typeOptions = ["Count", "Order", "Count & Samples", "Only Samples"];
    const PriorityOptions = ["P1", "P2", "P3", "P4"];
    const teamStatusOptions = [
      "Yet To Start",
      "Completed",
      "Draft",
      "In Progress",
      "Delay",
      "Rework",
      "Hold",
      "Assigned",
      "Internally Completed",
      "Partially Completed",
    ];
    return (
      <>
        <Box
          component="span"
          sx={{
            display: "inline",
            mx: "2px",
            transform: "scale(0.8)",
            width: "100%",
            boxShadow: "none !important",
          }}
        >
          { }
          <div style={{ overflow: "auto", borderRadius: "5px" }}>
            <table className="" {...getTableProps()} style={styles.table}>
              <thead style={styles.headerRow}>
                { }
                <Modal
                  open={isDialogOpen}
                  onClose={cancelDelete}
                  disableBackdropClick
                  aria-labelledby="custom-modal-title"
                  aria-describedby="custom-modal-description"
                  className="custom-modal"
                >
                  <Box sx={modalStyle}>
                    { }
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "left",
                        paddingTop: "24px",
                        paddingLeft: "32px",
                        paddingRight: "32px",
                        borderBottom: "none",
                      }}
                    >
                      <h2
                        id="custom-modal-title"
                        style={{
                          fontSize: "20px",
                          margin: 0,
                          marginTop: "5px",
                        }}
                      >
                        Confirm Action
                      </h2>
                      <button
                        type="button"
                        onClick={cancelDelete}
                        className="custom-modal-close-button"
                      >
                        <img
                          src={CloseImg}
                          alt="close"
                          width={20}
                          height={20}
                          style={{ marginLeft: "8px" }}
                        />
                      </button>
                    </Box>
                    { }
                    <Box
                      sx={{
                        paddingLeft: "32px",
                        paddingRight: "32px",
                        paddingBottom: "24px",
                        paddingTop: "16px",
                      }}
                    >
                      <p id="custom-modal-description" style={{ margin: 0 }}>
                        Are you sure you want to delete this ?
                      </p>
                    </Box>
                    { }
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "12px",
                        paddingLeft: "32px",
                        paddingRight: "32px",
                        paddingBottom: "24px",
                      }}
                    >
                      <button
                        onClick={cancelDelete}
                        style={{
                          background: "transparent",
                          color: "#255AF0",
                          border: "2px solid #255AF0",
                          padding: "8px 16px",
                          borderRadius: "6px",
                          cursor: "pointer",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#e5e7eb")
                        }
                        onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          "transparent")
                        }
                      >
                        No
                      </button>
                      <button
                        onClick={() => {
                          if (deleteInfo.deleteType === "inclusion-exclusion") {
                            inclusionExclusionRowDelete(
                              deleteInfo.selectedSearchID
                            );
                          } else {
                            handleDelete(deleteInfo);
                          }
                          setIsDialogOpen(false);
                        }}
                        style={{
                          background: "#255AF0",
                          color: "white",
                          padding: "8px 16px",
                          borderRadius: "6px",
                          border: "none",
                          cursor: "pointer",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#255AF0")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor = "#255AF0")
                        }
                      >
                        Yes
                      </button>
                    </Box>
                  </Box>
                </Modal>
                {headerGroups.map((headerGroup) => (
                  <tr
                    {...headerGroup.getHeaderGroupProps()}
                    style={{
                      backgroundColor: "#F8F8F9",
                      color: "#252C34",
                    }}
                  >
                    {rows.length > 0 || tableName === "resultTable" ? (
                      <>
                        <th style={styles.serialNumberCell}>S.No</th>
                        {[...headerGroup.headers]
                          .filter(
                            (column) =>
                              ![
                                "updated At",
                                "Email Address",
                                "Internal Track",
                                "Client Status",
                              ].includes(column.render("Header"))
                          )
                          .sort((a, b) =>
                            a.render("Header") === "Priority"
                              ? -1
                              : b.render("Header") === "Priority"
                                ? 1
                                : a.render("Header") === "Type" &&
                                  b.render("Header") !== "Priority"
                                  ? -1
                                  : b.render("Header") === "Type" &&
                                    a.render("Header") !== "Priority"
                                    ? 1
                                    : a.render("Header") === "Action"
                                      ? 1
                                      : b.render("Header") === "Action"
                                        ? -1
                                        : a.render("Header") === "Client Status"
                                          ? 1
                                          : b.render("Header") === "Client Status"
                                            ? -1
                                            : 0
                          )
                          .filter(
                            (column, index, self) =>
                              self.findIndex(
                                (c) =>
                                  c.render("Header") === column.render("Header")
                              ) === index
                          )
                          .map((column) => (
                            <th
                              {...(tableType !== "custom data view table"
                                ? {
                                  ...column.getHeaderProps(
                                    column.getSortByToggleProps()
                                  ),
                                }
                                : {})}
                              style={
                                column.render("Header") === "Action" &&
                                  tableType === "Saved Search"
                                  ? styles?.headerCellAction
                                  : tableType === "custom data view table" &&
                                    column.render("Header") === "Action"
                                    ? styles?.customActionCell
                                    : tableType === "custom data view table" &&
                                      (column.render("Header") ===
                                        "Team Status" ||
                                        column.render("Header") ===
                                        "Client Status")
                                      ? styles?.headerCellforSpecificHeader
                                      : column.render("Header") === "Task Name"
                                        ? styles.headerCellTaskName
                                        : styles.headerCell
                              }
                            >
                              <span
                                style={{
                                  display: "flex",

                                  justifyContent: "left",
                                }}
                              >
                                {column.render("Header")}
                                {(column.render("Header") === "Client Status" ||
                                  column.render("Header") === "Status") &&
                                  tableType === "custom data view table" && (
                                    <>
                                      <span
                                        style={{
                                          marginLeft: "8px",
                                          cursor: "pointer",
                                          position: "static",
                                        }}
                                      >
                                        <TableFilterMenu
                                          options={statusOptions}
                                          selectedOption={selectedOption}
                                          setSelectedOption={setSelectedOption}
                                          menuName={"status"}
                                        />
                                      </span>
                                      {selectedOption?.status.length > 0 && (
                                        <div
                                          style={{
                                            height: "20px",
                                            width: "20px",
                                            background: "darkblue",
                                            borderRadius: "5px",
                                            marginTop: "0px",
                                          }}
                                        >
                                          <p>{selectedOption.status.length}</p>
                                        </div>
                                      )}
                                    </>
                                  )}
                                {column.render("Header") === "Type" &&
                                  tableType === "custom data view table" && (
                                    <>
                                      <span
                                        style={{
                                          marginLeft: "8px",
                                          cursor: "pointer",
                                          position: "relative",
                                        }}
                                      >
                                        <TableFilterMenu
                                          options={typeOptions}
                                          selectedOption={selectedOption}
                                          setSelectedOption={setSelectedOption}
                                          menuName={"type"}
                                        />
                                      </span>
                                      {selectedOption.type.length > 0 && (
                                        <div
                                          style={{
                                            height: "20px",
                                            width: "20px",
                                            background: "darkblue",
                                            borderRadius: "5px",
                                            marginTop: "0px",
                                          }}
                                        >
                                          <p>{selectedOption.type.length}</p>
                                        </div>
                                      )}
                                    </>
                                  )}
                                {column.render("Header") === "Priority" &&
                                  tableType === "custom data view table" && (
                                    <>
                                      <span
                                        style={{
                                          marginLeft: "8px",
                                          cursor: "pointer",
                                          position: "relative",
                                        }}
                                      >
                                        <TableFilterMenu
                                          options={PriorityOptions}
                                          selectedOption={selectedOption}
                                          setSelectedOption={setSelectedOption}
                                          menuName={"priority"}
                                        />
                                      </span>
                                      {selectedOption.priority.length > 0 && (
                                        <div
                                          style={{
                                            height: "20px",
                                            width: "20px",
                                            background: "darkblue",
                                            borderRadius: "5px",
                                            marginTop: "0px",
                                          }}
                                        >
                                          <p>
                                            {selectedOption.priority.length}
                                          </p>
                                        </div>
                                      )}
                                    </>
                                  )}
                                {column.render("Header") === "Team Status" &&
                                  tableType === "custom data view table" && (
                                    <>
                                      <span
                                        style={{
                                          marginLeft: "8px",
                                          cursor: "pointer",
                                          position: "relative",
                                        }}
                                      >
                                        <TableFilterMenu
                                          options={teamStatusOptions}
                                          selectedOption={selectedOption}
                                          setSelectedOption={setSelectedOption}
                                          menuName={"teamStatus"}
                                        />
                                      </span>
                                      {selectedOption?.teamStatus.length >
                                        0 && (
                                          <div
                                            style={{
                                              height: "20px",
                                              width: "20px",
                                              background: "darkblue",
                                              borderRadius: "5px",
                                              marginTop: "0px",
                                            }}
                                          >
                                            <p>
                                              {selectedOption?.teamStatus.length}
                                            </p>
                                          </div>
                                        )}
                                    </>
                                  )}
                              </span>
                            </th>
                          ))}
                      </>
                    ) : (
                      ""
                    )}
                  </tr>
                ))}
              </thead>
              { }
              <tbody {...getTableBodyProps()}>
                {rows.length > 0 ? (
                  rows.map((row, index) => {
                    prepareRow(row);
                    return (
                      <tr
                        {...row.getRowProps()}
                        style={
                          tableType === "custom data view table" &&
                            (userRole === 2 || userRole === 3)
                            ? row?.original?.type?.toLowerCase() === "order"
                              ? styles?.customOrderRows
                              : styles?.customCountRows
                            : styles?.row
                        }
                      >
                        <>
                          { }
                          { }
                          <td style={styles.cell}>
                            {entriesToShow * currentPage + (index + 1)}
                          </td>
                          { }
                          {[...row.cells]
                            .filter(
                              (column) =>
                                ![
                                  "updated At",
                                  "Email Address",
                                  "Internal Track",
                                  "Client Status",
                                ].includes(column.render("Header"))
                            )
                            .sort((a, b) =>
                              a.render("Header") === "Priority"
                                ? -1
                                : b.render("Header") === "Priority"
                                  ? 1
                                  : a.render("Header") === "Type" &&
                                    b.render("Header") !== "Priority"
                                    ? -1
                                    : b.render("Header") === "Type" &&
                                      a.render("Header") !== "Priority"
                                      ? 1
                                      : a.render("Header") === "Action"
                                        ? 1
                                        : b.render("Header") === "Action"
                                          ? -1
                                          : a.render("Header") === "Client Status"
                                            ? 1
                                            : b.render("Header") === "Client Status"
                                              ? -1
                                              : 0
                            )
                            .map((cell) => (
                              <>
                                {cell.column.Header === "Priority" &&
                                  tableType === "custom data view table" ? (
                                  <td
                                    {...cell.getCellProps()}
                                    style={{
                                      ...styles.cell,
                                      backgroundColor: ["P1", "P2"].includes(
                                        cell.value
                                      )
                                        ? cell.value === "P1"
                                          ? "red"
                                          : "orange"
                                        : undefined,
                                      textAlign: "left",
                                    }}
                                  >
                                    {cell.render("Cell")}
                                  </td>
                                ) : cell.column.Header === "Team Status" &&
                                  tableType === "custom data view table" ? (
                                  <td
                                    {...cell.getCellProps()}
                                    style={{
                                      ...styles.cell,
                                      backgroundColor: [
                                        "New",
                                        "Yet To Start",
                                        "Draft",
                                      ].includes(cell.value)
                                        ? "white"
                                        : ["In Progress", "Hold"].includes(
                                          cell.value
                                        )
                                          ? "orange"
                                          : cell.value === "Completed"
                                            ? "green"
                                            : [
                                              "Delay",
                                              "rework",
                                              "Rework",
                                            ].includes(cell.value)
                                              ? "red"
                                              : "gray",
                                      color: [
                                        "New",
                                        "Yet To Start",
                                        "Draft",
                                      ].includes(cell.value)
                                        ? "black"
                                        : "white",
                                    }}
                                  >
                                    {cell.render("Cell")}
                                  </td>
                                ) : cell.column.Header === "Title" ? (
                                  <td
                                    {...cell.getCellProps()}
                                    style={styles.cells}
                                  >
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        width: "60%",
                                      }}
                                    >
                                      <Tooltip
                                        title={cell.value}
                                        arrow
                                        placement="top"
                                      >
                                        <span
                                          style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            maxWidth: "200px",
                                            display: "inline-block",
                                          }}
                                        >
                                          {cell.value?.length > 5
                                            ? `${cell.value
                                              .replace(/_/g, " ")
                                              .split(" ")
                                              .map(
                                                (w) =>
                                                  w.charAt(0).toUpperCase() +
                                                  w.slice(1)
                                              )
                                              .join(" ")}`
                                            : // .slice(0, 20)}...`
                                            cell.value}
                                        </span>
                                      </Tooltip>
                                    </span>
                                  </td>
                                ) : cell.column.Header === "Selected Fields" ? (
                                  <td
                                    {...cell.getCellProps()}
                                    style={styles.cells}
                                  >
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-start",
                                        gap: "6px",
                                        width: "100%",
                                        cursor: "pointer",
                                        color: "#255AF0",
                                      }}
                                      onClick={() => {
                                        const newDrawerData =
                                          getFilteredSelectedFields(
                                            cell.row.original?.data || {}
                                          );
                                        const title = formatLabel(
                                          cell.row.original?.title ||
                                          "Selected Fields"
                                        );
                                        setDrawerTitle(title);
                                        setDrawerData(newDrawerData);
                                        setDrawerOpen(true);
                                      }}
                                    >
                                      <LuSettings2 size={14} />
                                      <span style={{ fontSize: "12px" }}>
                                        Fields
                                      </span>
                                    </span>
                                  </td>
                                ) : cell.column.Header === "Type" ? (
                                  <td
                                    {...cell.getCellProps()}
                                    style={styles.cells}
                                  >
                                    <Tooltip
                                      title={
                                        <span
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                        >
                                          {typeof cell.value === "string"
                                            ? (() => {
                                              let formatted = cell.value
                                                .replace(/_/g, " ")
                                                .trim();
                                              return (
                                                formatted
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                formatted.slice(1)
                                              );
                                            })()
                                            : cell.value}
                                          <CopyToClipboard text={cell.value}>
                                            <ContentCopyIcon
                                              style={styles.copyIcon}
                                            />
                                          </CopyToClipboard>
                                        </span>
                                      }
                                      enterDelay={500}
                                      enterNextDelay={300}
                                      placement="top"
                                      arrow
                                    >
                                      <span>
                                        {typeof cell.value === "string"
                                          ? (() => {
                                            let formatted = cell.value
                                              .replace(/_/g, " ")
                                              .trim();
                                            return (
                                              formatted
                                                .charAt(0)
                                                .toUpperCase() +
                                              formatted.slice(1)
                                            );
                                          })()
                                          : cell.value}
                                      </span>
                                    </Tooltip>
                                  </td>
                                ) : cell.column.id === "userName" &&
                                  userRole !== 1 ? (
                                  <td
                                    {...cell.getCellProps()}
                                    style={styles.cell}
                                  >
                                    { }
                                    <a
                                      href={`/owner-profile?userId=${row.original.userId}`}
                                      style={{ color: "white" }}
                                    >
                                      {cell.render("Cell")}
                                    </a>
                                  </td>
                                ) : (
                                  <td
                                    {...cell.getCellProps()}
                                    style={styles.cell}
                                  >
                                    {cell.render("Cell")}
                                  </td>
                                )}
                              </>
                            ))}
                        </>
                      </tr>
                    );
                  })
                ) : (
                  <tr style={styles.row}>
                   <div className="tw-text-center tw-text-gray-500 tw-py-4 tw-border-b tw-border-l tw-border-r tw-border-gray-300 tw-w-full">
                                          <div className="tw-text-center tw-text-gray-500 tw-py-6">
                                              <div className="tw-flex tw-justify-center tw-mb-4">
                                                  <IconWithBackground
                                                      icon="flowbite:shapes-outline"
                                                      size={30}
                                                      color="#ffc2d3"
                                                      bgColor="#fff6f8"
                                                  />
                                              </div>
                                              <div className="tw-flex tw-justify-center tw-mb-4">
                                                  <span className="tw-text-default tw-font-semibold tw-text-black">
                                                      No Data Available
                                                  </span>
                                              </div>
                                              <div className="tw-flex tw-justify-center tw-mb-4">
                                                  <span className="tw-text-xs">
                                                      There is no recent data available.
                                                  </span>
                                              </div>
                                          </div>
                                      </div>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {rows.length > 0 && (
            <div className="historyTablePage pagination-dv-table d-flex align-items-left justify-content-between">
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  marginBottom: "2px",
                  paddingTop: "20px",
                  width: "50%",
                }}
              >
                Showing{" "}
                <span className="dropdown-usage">
                  <select
                    className="select"
                    style={{
                      fontSize: "12px",
                      width: "40px",
                      height: "24px",
                      border: " 1px solid #255AF0",
                      marginRight: "5px",
                      borderRadius: "3px",
                      outline: "none",
                    }}
                    value={entriesToShow}
                    onChange={handleEntriesToShowChange}
                  >
                    {[2, 10, 25, 50, 100].map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </span>{" "}
                { }
                of{" "}
                {tableName === "resultTable" ||
                  keyword === "emailValidation" ||
                  tableType === "Saved Search" ||
                  tableType === "Inclusion and Exclusion"
                  ? totalpage
                  : pagination?.totalDocuments ?? 0}{" "}
                entries
              </p>
              { }
              <Stack spacing={2} alignItems="left" mt={2}>
                <Pagination
                  count={pageCount}
                  page={currentPage + 1}
                  onChange={handleChange}
                  variant="outlined"
                  color="primary"
                  shape="rounded"
                  size="medium"
                />
              </Stack>
            </div>
          )}
          { }
        </Box>
        { }
        <Modal open={reworkModal} onClose={handleReWorkModal}>
          <Box
            sx={{
              ...style,
              width: "435px",
              height: "auto",
              maxHeight: "95%",
              maxWidth: "95%",
              padding: "16px",
            }}
          >
            <div className="d-flex justify-content-between">
              <h5>Rework Details</h5>
              <svg
                className="new-col-close-btn-svg"
                onClick={handleReWorkModal}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.3"
                  y="0.3"
                  width="23.4"
                  height="23.4"
                  rx="11.7"
                  stroke="#E5E5E5"
                  strokeWidth="0.6"
                />
                <path
                  d="M15.6004 15.5999L12.0004 11.9999M12.0004 11.9999L8.40039 8.3999M12.0004 11.9999L15.6004 8.3999M12.0004 11.9999L8.40039 15.5999"
                  stroke="#191921"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                handleReworkDetails();
              }}
            >
              <Form.Group>
                <Form.Label>Enter Rework Details</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Rework Information"
                  onChange={(e) => {
                    setReWorkData((prev) => ({
                      ...prev,
                      reworkDetails: e.target.value,
                    }));
                  }}
                />
              </Form.Group>
              <div className="d-flex justify-content-end">
                <button type="submit" className="btn OverallBtn mt-3 searchBtn">
                  Rework
                </button>
              </div>
            </Form>
          </Box>
        </Modal>
        <Modal open={deleteModal} onClose={handleDeleteModal}>
          <Box
            sx={{
              ...style,
              width: "435px",
              height: "auto",
              maxHeight: "95%",
              maxWidth: "95%",
              padding: "16px",
            }}
          >
            <div className="d-flex justify-content-between">
              <h5>Delete Order</h5>
              <svg
                className="new-col-close-btn-svg"
                onClick={handleDeleteModal}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.3"
                  y="0.3"
                  width="23.4"
                  height="23.4"
                  rx="11.7"
                  stroke="#E5E5E5"
                  strokeWidth="0.6"
                />
                <path
                  d="M15.6004 15.5999L12.0004 11.9999M12.0004 11.9999L8.40039 8.3999M12.0004 11.9999L15.6004 8.3999M12.0004 11.9999L8.40039 15.5999"
                  stroke="#191921"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div>
              <p className="deleteContent">
                Are you sure you want to <span>delete</span> this order?
              </p>
              <button
                type="submit"
                className="btn mt-3 deleteBtn"
                onClick={() => {
                  handlePlaceOrder("Deleted");
                }}
              >
                Delete
              </button>
            </div>
          </Box>
        </Modal>
        { }
        { }
        {orderPlaced && (
          <InfoBar
            Information={"Order Updated Successfully"}
            flag={true}
            popupState={orderPlaced}
            setPopupState={setOrderPlaced}
          />
        )}

        <Drawer
          anchor="right" // ← changed from "left" to "right"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          PaperProps={{
            style: {
              width: "320px",
              padding: "20px",
              fontSize: "14px",
            },
          }}
        >
          <Typography
            variant="h5"
            style={{
              fontSize: "16px",
              fontWeight: "500",

              marginTop: "20px",
              color: "#255AF0",
              textAlign: "left",
            }}
          >
            {drawerTitle}
          </Typography>
          <span
            style={{
              fontSize: "12px",
              color: "gray",
              textAlign: "left",
              marginBottom: "30px",
              marginTop: "5px",
            }}
          >
            Selected (Bundles & Fields) in Prospect Search
          </span>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "16px",
            }}
          >
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="searchstyle"
            />
          </div>

          {drawerData &&
            Object.entries(drawerData)
              .filter(([key, value]) =>
                key.toLowerCase().includes(searchTerm.toLowerCase())
              )
              .map(([key, value]) => {
                const isEmptyValue = (val) => {
                  if (
                    val === null ||
                    val === undefined ||
                    val === "" ||
                    val === "null"
                  )
                    return true;
                  if (Array.isArray(val)) return val.length === 0;
                  if (typeof val === "object") {
                    const entries = Object.entries(val);
                    return entries.every(([_, v]) => isEmptyValue(v));
                  }
                  return false;
                };

                const excludedKeys = [
                  "startRange",
                  "endRange",
                  "minStartRange",
                  "minEndRange",
                  "maxStartRange",
                  "maxEndRange",
                ];

                if (
                  typeof value === "object" &&
                  Object.entries(value).every(
                    ([k, v]) =>
                      excludedKeys.includes(k) ||
                      isEmptyValue(v) ||
                      (k === "minValue" && (v === null || v === "null")) ||
                      (k === "maxValue" && (v === null || v === "null"))
                  )
                )
                  return null;

                if (isEmptyValue(value)) return null;

                return (
                  <div key={key} style={{ marginBottom: "10px" }}>
                    <span style={{ fontSize: "14px", fontWeight: "600" }}>
                      {key}:
                    </span>
                    {Array.isArray(value) ? (
                      value.map((item, i) => (
                        <div
                          key={i}
                          style={{
                            marginBottom: "5px",
                            display: "flex",
                            alignItems: "center",
                            fontSize: "14px",
                          }}
                        >
                          <TbPoint
                            style={{
                              color: "#255AF0",
                              fontSize: "12px",
                              marginRight: "6px",
                              flexShrink: 0,
                            }}
                          />
                          <span>
                            {item.label || item.value || JSON.stringify(item)}
                          </span>
                        </div>
                      ))
                    ) : typeof value === "object" && value?.selectedValues ? (
                      value.selectedValues.map((item, i) => (
                        <div
                          key={i}
                          style={{
                            marginBottom: "5px",
                            display: "flex",
                            alignItems: "center",
                            fontSize: "14px",
                          }}
                        >
                          <TbPoint
                            style={{
                              color: "#255AF0",
                              fontSize: "12px",
                              marginRight: "6px",
                              flexShrink: 0,
                            }}
                          />
                          <span>
                            {item.label || item.value || JSON.stringify(item)}
                          </span>
                        </div>
                      ))
                    ) : typeof value === "object" ? (
                      Object.entries(value)
                        .filter(
                          ([k, v]) =>
                            !excludedKeys.includes(k) && !isEmptyValue(v)
                        )
                        .map(([k, v], i) => (
                          <div
                            key={i}
                            style={{ fontSize: "14px", marginBottom: "5px" }}
                          >
                            <strong>{k}:</strong>{" "}
                            {typeof v === "object" ? JSON.stringify(v) : v}
                          </div>
                        ))
                    ) : (
                      <div style={{ fontSize: "14px" }}>{value}</div>
                    )}
                  </div>
                );
              })}
        </Drawer>
      </>
    );
  }
);
export default HistoryTable;
const styles = {
  headerRow: {
    backgroundColor: "#f4f5f5",
    height: "auto",
  },
  table: {
    borderCollapse: "none !important",
    border: "1px solid #ddd",
    maxWidth: "100%",
    tableLayout: "fixed",
    width: "100%",
    margin: "0px auto",
    borderRadius: "5px !important",
  },
  headerCellforSpecificHeader: {
    border: "1px solid #ddd",
    padding: "7px 10px",
    color: "#5E6976",
    fontWeight: "400",
    fontSize: "12px",
    maxWidth: "250px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minWidth: "150",
    width: "170px",
    textAlign: "left",
  },
  headerCell: {
    backgroundColor: "#F8F8F9",
    padding: "7px 10px",
    color: "rgb(94, 105, 118)",
    fontWeight: "400",
    fontSize: "12px",
    maxWidth: "250px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minWidth: "150",
    width: "150px",
    textAlign: "left",
    fontWeight: "400",
    height: "48px",
    pointerEvents: "none",
  },
  headerCellTaskName: {
    border: "1px solid #ddd",
    padding: "7px 10px",
    color: "white",
    fontWeight: "400",
    fontSize: "13px",
    maxWidth: "271px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minWidth: "150",
    width: "207px",
    textAlign: "left",
  },
  headerCellAction: {
    padding: "7px 10px",
    color: "#5E6976",
    fontWeight: "400",
    fontSize: "13px",
    maxWidth: "280px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minWidth: "150",
    width: "145px",
    textAlign: "left",
    fontWeight: "500",
    position: "sticky",
    top: "0",
    zIndex: "1",
  },
  customActionCell: {
    border: "1px solid #ddd",
    padding: "7px 10px",
    color: "white",
    fontWeight: "500",
    fontSize: "13px",
    maxWidth: "300px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minWidth: "150",
    width: "85px",
    textAlign: "left",
  },
  serialNumberCell: {
    padding: "7px 10px",
    color: "#252C34",
    fontWeight: "500",
    fontSize: "12px",
    maxWidth: "250px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minWidth: "135px",
    width: "80px",
    textAlign: "left",
  },
  row: {
    height: "auto",
  },
  customCountRows: {
    backgroundColor: "#E80070",
    color: "white",
    height: "auto",
  },
  customOrderRows: {
    backgroundColor: "blueviolet",
    color: "white",
    height: "auto",
  },
  cell: {
    textAlign: "left",
    padding: "7px 10px",
    textOverflow: "ellipsis",

    height: "50px",
    maxHeight: "75px",
    fontSize: "12px",
    fontWeight: "500",
    maxWidth: "50px",
    width: "30px",
    borderBottom: "1px solid #E2E4E7",
  },
  cells: {
    padding: "7px 10px",
    textOverflow: "ellipsis",
    borderBottom: "1px solid rgb(226, 228, 231)",
    maxWidth: "170px",
    height: "50px",
    maxHeight: "75px",
    fontSize: "12px",
    fontWeight: "500",
  },
  noDataCell: {
    padding: "7px 10px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxWidth: "170px",
    height: "50px",
    maxHeight: "75px",
    fontSize: "12px",
    fontWeight: "500",
  },
  spanCell: {
    textOverflow: "ellipsis",
    marginLeft: "5px",
    overflow: "hidden",
    maxWidth: "135px",
    fontSize: "12px",
    fontWeight: "500",
    maxHeight: "19px",
    display: "block",
    whiteSpace: "nowrap",
  },
  copyIcon: {
    width: "19px",
    paddingLeft: "6px",
  },
};
